export const headers = [
  {
    id: 1,
    name: "Home",
    path: "/",
  },
  {
    id: 2,
    name: "About Us",
    sub: [
      { name: "Our History", path: "history" },
      { name: "Mission", path: "mission" },
      { name: "Vision", path: "vision" },
      { name: "Leadership", path: "team" },
    ],
  },
  {
    id: 3,
    name: "Services",
    sub: [
      { name: "FX Liquidity", path: "service1" },
      { name: "Remittances", path: "service2" },
      { name: "Advisory", path: "service3" },
    ],
  },
  {
    id: 4,
    name: "Career",
    path: "/career",
  },
  {
    id: 5,
    name: "Contact Us",
    path: "/contact-us",
  },
  {
    id: 6,
    name: "Client Portal",
    path: "/portal/login",
  },
];

export const contactLinks = [
  { title: "08055058367", url: "tel:08055058367", img: "/assets/phone.svg" },
  {
    title: "info@transalliancecapital.ng",
    url: "mailto:info@transalliancecapital.ng",
    img: "/assets/mail.svg",
  },
  {
    title: "No 200c Muri Okunola Street VI Lagos",
    img: "/assets/location.svg",
  },
];

export const faqs = [
  {
    question: "How do I cancel an order?",
    answer:
      "Contact your dedicated account manager or use our platform's order cancellation feature within the allowable time frame. Our team confirms all cancellations in writing for your records.",
  },
  {
    question: "Do you charge any commission or fees?",
    answer:
      "No. We don't charge our customers commission or hidden fees. Our pricing is fully transparent and quoted upfront on every trade.",
  },
  {
    question: "What is the highest volume I can trade?",
    answer:
      "There is no fixed upper limit. Larger trades may require pre-approval and a short conversation to agree the terms, but we routinely support institutional-scale volumes.",
  },
  {
    question: "Which currencies do you trade in the FX market?",
    answer:
      "We offer trading in all major currencies, including NGN, USD, EUR, GBP, JPY, CAD, AUD, CHF and more. Ask us about exotic pairs, chances are we can help.",
  },
  {
    question: "How secure and confidential are my transactions with TransCap?",
    answer:
      "We use industry-leading encryption and compliance protocols (including KYC and AML documentation) to ensure the highest level of security and confidentiality.",
  },
  {
    question: "Is TransCap licensed to operate in the FX market?",
    answer:
      "Yes. TransAlliance Capital is fully licensed and regulated to operate in the FX market, ensuring compliance with all relevant regulations. Licensing evidence is available in the About Us section.",
  },
];

export const contactIcons = [
  {
    img: "/assets/call.svg",
    altImg: "/assets/alt-call.svg",
    url: "tel:08055058367",
    title: "Call",
    text: "08055058367",
  },
  {
    img: "/assets/email.svg",
    altImg: "/assets/alt-email.svg",
    url: "mailto:info@transalliancecapital.ng",
    text: "info@transalliancecapital.ng",
    title: "Email",
  },
  {
    img: "/assets/loc.svg",
    altImg: "/assets/alt-loc.svg",
    text: "No 200c Muri Okunola Street VI Lagos",
    title: "Location",
  },
];

// Home stat cards, real numbers from transalliancecapital.ng
export const growth = [
  {
    value: 4000,
    suffix: "+",
    title: "Completed transactions",
    description: "Every trade closed, settled and reconciled end-to-end.",
    img: "/assets/p1.png",
  },
  {
    value: 400,
    suffix: "+",
    title: "Satisfied customers",
    description: "Institutions, corporates and individuals who trust us.",
    img: "/assets/p2.png",
  },
  {
    value: 10,
    suffix: "+",
    title: "States covered",
    description: "A nationwide desk with a pan-African outlook.",
    img: "/assets/p3.png",
  },
];

export const slides = [
  "/assets/slide1.png",
  "/assets/slide2.png",
  "/assets/slide3.png",
  "/assets/slide4.png",
  "/assets/slide5.png",
  "/assets/slide6.png",
  "/assets/slide7.png",
  "/assets/slide8.png",
  "/assets/slide9.png",
  "/assets/slide10.png",
  "/assets/slide11.png",
];

// New: home "why us" feature cards
export const features = [
  {
    icon: "shield",
    title: "Fully licensed & compliant",
    text: "Regulated operations, watertight KYC/AML, and audited controls at every step of the trade lifecycle.",
  },
  {
    icon: "bolt",
    title: "Best-in-class execution",
    text: "Deep liquidity pools and specialist desk pricing mean tighter spreads and faster fills, every time.",
  },
  {
    icon: "globe",
    title: "Borderless settlement",
    text: "One partner, dozens of corridors. NGN, USD, EUR, GBP and more, settled where you need them.",
  },
  {
    icon: "chart",
    title: "Advisory that adds alpha",
    text: "A specialist finance team tracking global flows so your FX strategy stays a step ahead of the market.",
  },
];

// New: home testimonial teaser
export const testimonials = [
  {
    quote:
      "TransCap has become an extension of our treasury team. Their pricing is honest and their fills are consistent, even during volatile sessions.",
    name: "Adaobi N.",
    role: "Head of Treasury, Manufacturing Group",
  },
  {
    quote:
      "Cross-border settlements that used to take days now clear in hours. The operational lift for our finance team has been huge.",
    name: "Marcus O.",
    role: "CFO, Regional Fintech",
  },
  {
    quote:
      "Reliable, discreet, and unusually helpful. When our correspondent bank pulled a line, TransCap kept us moving.",
    name: "Zainab K.",
    role: "Partner, Trade Finance Advisory",
  },
];

// Real company copy
export const mission =
  "To consistently deliver superior value to all our stakeholders locally and globally.";

export const vision =
  "To be the preferred African partner in be-spoke financial service solutions.";

// Real core values, icons mirrored from transalliancecapital.ng
export const coreValues = [
  {
    title: "People",
    img: "/assets/core/core1.png",
    text: "We believe in nurturing our people, empowering them to grow and succeed together.",
  },
  {
    title: "Innovation",
    img: "/assets/core/core2.png",
    text: "We push boundaries, embracing fresh ideas and technologies to drive progress.",
  },
  {
    title: "Integrity",
    img: "/assets/core/core3.png",
    text: "We operate with honesty and transparency, building trust with every decision.",
  },
  {
    title: "Passion",
    img: "/assets/core/core4.png",
    text: "Our energy and commitment fuel everything we do, inspiring us to go the extra mile.",
  },
  {
    title: "Excellence",
    img: "/assets/core/core5.png",
    text: "We set high standards, continuously striving to deliver exceptional results in all we do.",
  },
];

// Real Executive Management, mirrored from transalliancecapital.ng
export const executiveTeam = [
  {
    name: "Kamsi Okafor",
    role: "Chairman",
    img: "/assets/team/team1.png",
  },
  {
    name: "Anthony Nwosu",
    role: "Chief Treasury & Operations Officer",
    img: "/assets/team/team2.png",
  },
  {
    name: "Femi Adedipe",
    role: "Chief Budget & Finance Officer",
    img: "/assets/team/team3.png",
  },
  {
    name: "Lovelyn Mark",
    role: "Chief Legal & Compliance Officer",
    img: "/assets/team/team4.png",
  },
  {
    name: "Olufemi Ojo-Omoniyi",
    role: "Chief Risk & Internal Control Officer",
    img: "/assets/team/team5.png",
  },
  {
    name: "Afam Obodizie",
    role: "Chief Strategy, Innovation & Research Officer",
    img: "/assets/team/team6.png",
  },
  {
    name: "Mayowa Igunbor",
    role: "Chief People & Communication Officer",
    img: "/assets/team/team7.png",
  },
  {
    name: "Anselm Fowel",
    role: "Chief Technology & Innovation Officer",
    img: "/assets/team/team8.png",
    link: "https://anselmfowel.com/contact.html",
  },
];

// Real Management Team
export const managementTeam = [
  {
    name: "Ifeoma Nweje",
    role: "Acting Managing Director",
    img: "/assets/team/team10.png",
  },
  {
    name: "Elsie Ogo",
    role: "Head of Admin",
    img: "/assets/team/team14.png",
  },
  {
    name: "Osaigbovo Ekhator",
    role: "Compliance Manager",
    img: "/assets/team/team16.png",
  },
];

// Social channels. Empty `url` means "not published yet" and will render as a
// disabled tile in the footer.
export const socialLinks = [
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/transalliance-capital",
    icon: "linkedin",
  },
  {
    name: "Twitter",
    url: "https://twitter.com/TransCap",
    icon: "twitter",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/transalliancecapital",
    icon: "instagram",
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/transalliancecapital",
    icon: "facebook",
  },
];

// Legal / policy pages.
export const legalLinks = [
  { name: "Privacy", path: "/privacy" },
  { name: "Terms", path: "/terms" },
  { name: "Compliance", path: "/compliance" },
];

